import { useCallback, useEffect, useState } from 'react';
import { PageContainer, SurfaceCard } from '@react-apps/design-system';
import { ViewAsPicker } from '@/shared/view-as/ViewAsControl';
import { useIsRealAdmin } from '@/shared/view-as/use-effective-roles';

export function SettingsPage() {
  const isRealAdmin = useIsRealAdmin();

  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains('dark'),
  );

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = useCallback(() => {
    setIsDark((prev) => !prev);
  }, []);

  return (
    <PageContainer maxWidth="6xl">
      <div>
        <h1 className="text-(--color-text-primary) text-2xl font-bold">
          Settings
        </h1>
        <p className="text-(--color-text-secondary) mt-1 text-sm">
          Manage your application preferences
        </p>
      </div>

      <SurfaceCard className="shadow-sm">
        <h2 className="text-(--color-text-primary) text-lg font-semibold">
          Appearance
        </h2>
        <p className="text-(--color-text-secondary) mt-1 text-sm">
          Customize the look and feel of the dashboard
        </p>

        <div className="mt-6 flex items-center justify-between">
          <div>
            <p className="text-(--color-text-primary) text-sm font-medium">
              Dark Mode
            </p>
            <p className="text-(--color-text-secondary) text-xs">
              Toggle between light and dark theme
            </p>
          </div>
          <button
            onClick={toggleTheme}
            role="switch"
            aria-checked={isDark}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              isDark ? 'bg-(--color-accent)' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                isDark ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>
      </SurfaceCard>

      {isRealAdmin && (
        <SurfaceCard className="shadow-sm">
          <h2 className="text-(--color-text-primary) text-lg font-semibold">
            Visualização
          </h2>
          <p className="text-(--color-text-secondary) mt-1 text-sm">
            Veja o dashboard como outro papel veria — só afeta o gating de UI; o
            backend continua te tratando como admin.
          </p>

          <div className="mt-6 flex items-center justify-between gap-4">
            <div>
              <p className="text-(--color-text-primary) text-sm font-medium">
                Visualizar como
              </p>
              <p className="text-(--color-text-secondary) text-xs">
                Escolha um papel para testar as regras de rota e de menu.
              </p>
            </div>
            <ViewAsPicker />
          </div>
        </SurfaceCard>
      )}
    </PageContainer>
  );
}
